module.exports = __webpack_public_path__ + "static/media/hyperjump-name-logo.53e62b2d.png";